"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Hammer, PaintBucket, Ruler, Cog } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Services() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: card3Ref,
    isVisible: card3Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const services = [{
    icon: Hammer,
    title: "Luxury Residential Renovations",
    description: "Bespoke home renovations designed around comfort, functionality, and elevated aesthetics. From full home transformations to custom kitchens and bathrooms, every space \n is crafted to last."
  }, {
    icon: PaintBucket,
    title: "Office & Commercial\n Fit-Outs",
    description: "Premium workspaces that communicate professionalism, performance, and identity — from executive offices to complete \n turn-key fit-outs."
  }, {
    icon: Cog,
    title: "Design & Build \n Services",
    description: "An integrated approach combining design, construction, and project management, ensuring clarity, efficiency, and flawless execution."
  }];
  return <section id="services" className="py-16 md:py-24 px-4 bg-background">
      <div className="container mx-auto max-w-7xl">
        <div ref={headingRef} className={`text-center mb-12 md:mb-16 transition-all duration-[var(--duration-medium)] ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl font-display text-foreground !font-bold md:text-4xl lg:text-5xl">Our Services</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          const refs = [card1Ref, card2Ref, card3Ref];
          const visibles = [card1Visible, card2Visible, card3Visible];
          return <div key={i} data-index={i} ref={refs[i]} className={`transition-all duration-[var(--duration-medium)] ${visibles[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full bg-primary border-none shadow-soft rounded-lg hover:-translate-y-1 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] p-6">
                  <CardHeader className="px-0 pt-0">
                    <div className="mb-4 inline-flex items-center justify-center w-14 h-14 mx-auto">
                      <Icon className="w-7 h-7 text-[#a03223]" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="whitespace-pre-line font-semibold text-xl font-display text-foreground !text-center md:text-2xl">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="px-0 pb-0">
                    <p className="whitespace-pre-line text-muted-foreground text-sm leading-relaxed !text-center md:text-base">
                      {service.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

        <div className="flex justify-center mt-12 md:mt-16">
        <a href="https://ksluxury.cloudtech.com.cy/services/" className="gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-9 has-[>svg]:px-3 inline-flex items-center justify-center rounded-full bg-accent text-foreground-accent font-semibold text-base focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] !p-6 disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-accent-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-accent-active active:translate-y-0">
  Explore Our Services
        </a>

        </div>
      </div>
    </section>;
}